/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-09-04 18:22:25
 * @Description: 
 */
import React, { useState } from 'react';
import ServiceInfoList from './components/ServiceInfoList';
import "./index.scss";

// 新能源电池健康保数据
const SohData = {
    name: "新能源电池健康保",
    desc: "当电池健康度(SOH)下降超过所选产品约定检测标准时，通过智能化修复技术，延长电池寿命、提升残值，降低用户使用成本，原厂质保期内补偿定额维修费用；原厂质保期外维修至服务合同约定标准。",
    image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/qib50tv9__w1840_h1544.png",
    infoList: [
        {
            title: "创新产品",
            desc: "创新推出动力电池自然衰减的专项保障产品，解决市场痛点",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/6es1g8d5__w128_h128.png"
        },
        {
            title: "全国保障",
            desc: "覆盖电池自然衰减的多种原因，提供维修/更换服务，确保电池性能",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/3k3bhm6u__w128_h128.png"
        },
        {
            title: "全国通赔",
            desc: "全国范围内均可享受赔付服务支持异地维修，无地域限制",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/ug4q2tji__w128_h128.png"
        },
        {
            title: "灵活自由",
            desc: "无强制保养，车辆过户不影响保障权益，真正做到随心驾驭",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/t8uqprb5__w128_h128.png"
        },
        {
            title: "专业服务",
            desc: "合作知名电池厂商，保障维修和更换服务的高质量与可靠性",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/5l6i97th__w128_h128.png"
        },
    ]
};

// 充电桩延保
const ChargingPileData = {
    name: "充电桩延保",
    desc: "保障新能源汽车充电桩延长保修，因产品质量问题无法使用，赔偿相关费用。",
    image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/ga4qjpsj__w3016_h1784.png",
    infoList: [
        {
            title: "巡检保养",
            desc: "外观/内部检查、功能检测、箱变保养",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/oqbolr1o__w128_h128.png"
        },
        {
            title: "现场服务",
            desc: "提供因产品质量问题导致的设备配件维修、更换及故障排除服务",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/kg0u4485__w128_h128.png"
        },
        {
            title: "服务时效",
            desc: "7*24小时客服支持，2小时响应，24小时内到场，48小时修复",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/i4namv80__w128_h128.png"
        },
        {
            title: "服务品控",
            desc: " 工程师持证上岗，工单、备件、维修全流程可视化追溯",
            icon: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/2mks83vc__w128_h128.png"
        }
    ]
};

const Index = () => {

    return (
        <div className="chefu-service">
            {/* banner */}
            <div className="chefu-service-banner">
                <div className="chefu-section-main">
                    <div className="chefu-service-banner-main">
                        <p className="chefu-service-banner-title">产品与服务</p>
                        <p>
                            专业团队全程护航车后服务，全链路保障覆盖，全国联保，让您畅享无忧出行。
                        </p>
                    </div>
                </div>
            </div>

            {/* 新能源电池健康保 */}
            <div className="chefu-service-soh">
                <div className="chefu-section-main">
                    <div className="chefu-section-title">{SohData.name}</div>
                    <div className="chefu-section-subtitle">{SohData.desc}</div>
                    <div className="chefu-service-soh-content">
                        <div className="chefu-service-soh-image">
                            <img src={SohData.image} alt={SohData.name} />
                        </div>
                        <ServiceInfoList data={SohData.infoList} />
                    </div>
                </div>
            </div>

            {/* 充电桩延保 */}
            <div className="chefu-service-chargingPile">
                <div
                    className="chefu-service-chargingPile-container"
                    style={{
                        backgroundImage: `url(${ChargingPileData.image})`,
                    }}
                >
                    <div className="chefu-section-main">
                        <div className="chefu-section-title">
                            {ChargingPileData.name}
                        </div>
                        <div className="chefu-section-subtitle">
                            {ChargingPileData.desc}
                        </div>
                        <div className="chefu-service-chargingPile-content">
                            <ServiceInfoList data={ChargingPileData.infoList} />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Index;